"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomePageCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _marked = _interopRequireDefault(require("marked"));

var _constellation = require("@zillow/constellation");

var _helper = require("../utils/helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Homepage card
 */
var HomePageCard = function HomePageCard(_ref) {
  var _props$zoom, _props$zoom2, _props$zoom3, _props$zoom4, _props$zoom5, _props$zoom6, _props$zoom7, _Object$assign;

  var buttonText = _ref.buttonText,
      clickAction = _ref.clickAction,
      hoverAction = _ref.hoverAction,
      defaultImageMedia = _ref.defaultImageMedia,
      description = _ref.description,
      forwardedRef = _ref.forwardedRef,
      handleCardLoaded = _ref.handleCardLoaded,
      headline = _ref.headline,
      optimizedImageMedia = _ref.optimizedImageMedia,
      legalText = _ref.legalText,
      props = _objectWithoutProperties(_ref, ["buttonText", "clickAction", "hoverAction", "defaultImageMedia", "description", "forwardedRef", "handleCardLoaded", "headline", "optimizedImageMedia", "legalText"]);

  return /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    as: _constellation.Card,
    cardType: "secondary",
    onMouseEnter: hoverAction,
    onClick: clickAction,
    sx: Object.assign(Object.assign({
      'display': 'flex',
      'flexFlow': 'wrap',
      'cursor': 'pointer'
    }, props.active ? {
      'transform': "scale(" + ((props === null || props === void 0 ? void 0 : (_props$zoom = props.zoom) === null || _props$zoom === void 0 ? void 0 : _props$zoom.toScale) || 1.05) + ") translate(-0px, -8px)",
      'transition': "all " + ((props === null || props === void 0 ? void 0 : (_props$zoom2 = props.zoom) === null || _props$zoom2 === void 0 ? void 0 : _props$zoom2.animationDuration) || 300) + "ms ease-in-out 0s",
      '&:after': {
        opacity: '1',
        transition: "all " + ((props === null || props === void 0 ? void 0 : (_props$zoom3 = props.zoom) === null || _props$zoom3 === void 0 ? void 0 : _props$zoom3.animationDuration) || 300) + "ms"
      }
    } : {}), {}, (_Object$assign = {
      'button': {
        marginTop: '$spacing.md',
        marginBottom: '$spacing.sm'
      },
      '&:hover': {
        'transform': "scale(" + ((props === null || props === void 0 ? void 0 : (_props$zoom4 = props.zoom) === null || _props$zoom4 === void 0 ? void 0 : _props$zoom4.toScale) || 1.05) + ") translate(-0px, -8px)",
        'transition': "all " + ((props === null || props === void 0 ? void 0 : (_props$zoom5 = props.zoom) === null || _props$zoom5 === void 0 ? void 0 : _props$zoom5.animationDuration) || 300) + "ms ease-in-out 0s",
        '&:after': {
          opacity: '1',
          transition: "all " + ((props === null || props === void 0 ? void 0 : (_props$zoom6 = props.zoom) === null || _props$zoom6 === void 0 ? void 0 : _props$zoom6.animationDuration) || 300) + "ms"
        },
        'button': {
          'backgroundColor': '$colors.brand',
          'color': '$colors.white',
          '&:hover': {
            backgroundColor: '$colors.brand',
            color: '$colors.white'
          }
        }
      },
      '&:after': {
        content: '',
        boxShadow: '0 5px 15px $colors.gray300',
        width: '100%',
        height: '100',
        opacity: '0',
        position: 'absolute',
        pointerEvents: 'none',
        top: '0',
        left: '0'
      },
      '@media $xs': {
        flex: '1 1 384px',
        textAlign: 'center'
      },
      '@media $md': {
        flex: '1 1 700px',
        textAlign: 'left'
      },
      '@media $xl': {
        flex: '2 1 280px',
        textAlign: 'center',
        padding: '$spacing.md'
      },
      'transition': "all " + ((props === null || props === void 0 ? void 0 : (_props$zoom7 = props.zoom) === null || _props$zoom7 === void 0 ? void 0 : _props$zoom7.animationDuration) || 300) + "ms ease-in-out 0s"
    }, _Object$assign["@media screen and (min-width: 1024px)"] = {
      display: 'flex'
    }, _Object$assign['&:last-of-type'] = {
      marginRight: '0px',
      marginBottom: '0px'
    }, _Object$assign), props.show ? {} : {
      visibility: 'hidden'
    })
  }, /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    sx: {
      'flex': '2 0 220px',
      'justifyContent': 'center',
      'display': 'flex',
      'height': 'auto',
      '@media $lg': {
        flex: '1 0 227px'
      },
      '@media $xl': {
        flex: '1 0 277px'
      },
      'marginTop': '$spacing.sm'
    }
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: (0, _helper.imageSrc)(optimizedImageMedia)
  }), /*#__PURE__*/_react.default.createElement(_constellation.Image, {
    alt: (0, _helper.imageAlt)(defaultImageMedia, headline),
    src: (0, _helper.imageSrc)(defaultImageMedia),
    width: "100%"
  }))), /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    sx: {
      'flex': '2 1 277px',
      'marginTop': '$spacing.sm',
      '@media $lg': {
        marginLeft: '$spacing.sm'
      },
      '@media $xl': {
        marginLeft: '$spacing.none'
      },
      '.rtb-card-body-text': {
        margin: '$spacing.sm $spacing.none $spacing.none'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    as: _constellation.Heading,
    level: 4,
    fontFamily: "serif"
  }, headline), /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    as: _constellation.Paragraph,
    className: "rtb-card-body-text",
    sx: {
      '@media screen and (min-width: 1025px)': {
        height: '96px',
        overflow: 'hidden'
      }
    }
  }, description), /*#__PURE__*/_react.default.createElement(_constellation.Button, {
    buttonType: props.active ? 'primary' : 'secondary'
  }, buttonText), /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    as: _constellation.Paragraph,
    fontType: "finePrint",
    className: "rtb-card-legal-text",
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    sx: {
      '@media screen and (min-width: 1025px)': {
        height: '40px',
        overflow: 'hidden'
      },
      'padding': '$spacing.xxs',
      'margin': '$spacing.none'
    },
    dangerouslySetInnerHTML: {
      __html: _marked.default.parseInline(legalText)
    }
  })));
};

exports.HomePageCard = HomePageCard;
HomePageCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Flag to check component is active
   */
  active: _propTypes.default.bool,

  /**
   * Text on the button displayed in the component
   */
  buttonText: _propTypes.default.string.isRequired,

  /**
   * Action on clicking the component
   */
  clickAction: _propTypes.default.func.isRequired,

  /**
   * Action on hover over the component
   */
  hoverAction: _propTypes.default.func.isRequired,

  /**
   * Default image media for image type as png/jpg supported by all browsers.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  defaultImageMedia: _propTypes.default.object,

  /**
   * Description displayed in the component.
   * Should not exceed 4 lines when screen width is 1025px.
   * Make sure to test this on QA for screen width above 1024px before publishing.
   */
  description: _propTypes.default.string.isRequired,

  /**
   * Used to pass child prop to parent
   */
  forwardedRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),

  /**
   * Action on image load in the component
   */
  handleCardLoaded: _propTypes.default.func,

  /**
   * Heading displayed in the component
   */
  headline: _propTypes.default.string.isRequired,

  /**
   * Optimized image media for advanced image types like webp.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  optimizedImageMedia: _propTypes.default.object,

  /**
   * Used to show the cards one after another
   */
  show: _propTypes.default.bool,

  /**
   * Zoom on hover over the component
   */
  zoom: _propTypes.default.shape({
    toScale: _propTypes.default.number,
    animationDuration: _propTypes.default.number
  }),

  /**
   * Legal text displayed at the bottom below the CTA button. Supports html.
   * If you want to update css, use class selector rtb-card-legal-text and apply css overrides.
   * Should not exceed 2 lines when screen width is 1025px.
   * Make sure to test this on QA for screen width above 1024px before publishing.
   */
  legalText: _propTypes.default.string
} : {};
HomePageCard.defaultProps = {
  handleCardLoaded: function handleCardLoaded() {},
  forwardedRef: _react.default.createRef(),
  active: false,
  show: true,
  zoom: {
    toScale: 1.02,
    animationDuration: 300
  },
  legalText: '',
  defaultImageMedia: null,
  optimizedImageMedia: null
};